export const SET_RESTAURANT_SETTINGS_CART_SETTINGS = 'SET_RESTAURANT_SETTINGS_CART_SETTINGS'
export const UPDATE_RESTAURANT_SETTINGS_CART_SETTING = 'UPDATE_RESTAURANT_SETTINGS_CART_SETTING'
export const SET_RESTAURANT_CHANGE_SETTINGS = 'SET_RESTAURANT_CHANGE_SETTINGS'
export const UPDATE_RESTAURANT_CHANGE_SETTING = 'UPDATE_RESTAURANT_CHANGE_SETTING'
export const SET_RESTAURANT_SETTINGS_WAITER_SETTINGS = 'SET_RESTAURANT_SETTINGS_WAITER_SETTINGS'
export const SET_RESTAURANT_SETTINGS_PRINT_SETTINGS = 'SET_RESTAURANT_SETTINGS_PRINT_SETTINGS'
export const SET_RESTAURANT_SETTINGS_PRESET_DISCOUNTS = 'SET_RESTAURANT_SETTINGS_PRESET_DISCOUNTS'
export const SET_RESTAURANT_SETTINGS_DISH_COURSES = 'SET_RESTAURANT_SETTINGS_DISH_COURSES'
export const SET_RESTAURANT_SETTINGS_NOTIFICATION_CONFIG = 'SET_RESTAURANT_SETTINGS_NOTIFICATION_CONFIG'
export const SET_RESTAURANT_SETTINGS_TABLE_TIMER_CONFIGS = 'SET_RESTAURANT_SETTINGS_TABLE_TIMER_CONFIGS'
